import client from "./client";

const cleanParams = (filters = {}) =>
  Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== undefined && value !== null && value !== "")
  );

export const getActivityLogs = async (filters = {}) => {
  const response = await client.get("/activity", {
    params: cleanParams(filters),
  });

  return response.data?.data || [];
};

export const createActivityLog = async (payload = {}) => {
  const response = await client.post("/activity/log", payload);
  return response.data;
};
